import React from 'react';

import { useRecoilValue } from 'recoil';

import { blockDateRange, blockDisplayHeader, customizedBlock } from 'venn-state';

import { Block } from '../../components/core';

import { BenchmarkType } from '../../components/secondary/benchmark-type';
import { DefaultDateRange } from '../../components/secondary/date-ranges';
import { RollingPeriod } from '../../components/secondary/rolling-period';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';
import { Venncast } from '../../components/secondary/venncast';

interface TimeSeriesHeaderProps {
  id: string;
}

export const TimeSeriesHeader = ({ id }: TimeSeriesHeaderProps) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const { selectedMetrics, relativeToBenchmark, subHeader } = useRecoilValue(customizedBlock(id));
  const dateRange = useRecoilValue(blockDateRange(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>
        <Block.Metadata id={id}>
          <DefaultDateRange dateRange={dateRange} />
          <BenchmarkType id={id} />
          {relativeToBenchmark && <Block.MetadataItem iconType="calculator">Relative to Benchmark</Block.MetadataItem>}
          <Venncast id={id} />
          <RollingPeriod id={id} />
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects id={id} metric={selectedMetrics[0] || ''} relativeToBenchmark={relativeToBenchmark} />
    </>
  );
};
